import React, { useState, useEffect, FC } from "react";
import { PageTitle } from "../../../_jutemplate/layout/core";

// custom hook
import { useUserRole } from "../../hooks/useUserRole";

// admin
import { Aggregator } from "./Aggregator";
import { Hanay } from "./Hanay";

export const DashboardPage = () => {

  const [superAdmin, hanayUser, aggregatorUser] = useUserRole();

  if (superAdmin || hanayUser) {
    return <Hanay />;
  } else if (aggregatorUser) {
    return <Aggregator />;
  } 

  return (
      <h2>Welcome To Dashboard</h2>
  )
};
